import * as React from "react";
const FoodAndNutritionSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M28 13h-1.046a11 11 0 0 0-21.908 0H4a1 1 0 0 0-1 1 13.043 13.043 0 0 0 7 11.535V26a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-.465A13.044 13.044 0 0 0 29 14a1 1 0 0 0-1-1Zm-3.058 0h-6.427a8.98 8.98 0 0 1 5.159-3.696A8.932 8.932 0 0 1 24.942 13Zm-3.257-5.971c.23.187.449.385.659.593a10.99 10.99 0 0 0-6.144 5.375h-3.688A9.033 9.033 0 0 1 21 7c.229 0 .457.011.685.029ZM16 4.999c.802.001 1.601.11 2.375.322A11.045 11.045 0 0 0 10.416 13H7.057A9.01 9.01 0 0 1 16 5Zm4.582 19a1 1 0 0 0-.582.913V26h-8v-1.088a1 1 0 0 0-.582-.912 11.036 11.036 0 0 1-6.375-9h21.91a11.037 11.037 0 0 1-6.37 9Z"
    />
  </svg>
);
export default FoodAndNutritionSVG;
